export default "__VITE_ASSET__DnS9OpH4__"